import React, { Component } from 'react';
import classNames from 'classnames';
import { FUNDRAISING_BASE_URI } from 'config';
import { containsCharityName } from 'src/helpers/api/create';
import Alert from 'src/components/Alert';
import { Link } from 'src/components/Analytics';
import { ValidationResult } from '../../helpers/validation';
import CharacterCount from '@justgiving/character-count';
import { FormattedMessage } from 'react-intl';
import { WrappedFieldProps } from 'redux-form';
import { CharityState } from 'src/redux/modules/charity/reducer';
import { ClickAnalyticsOptions } from 'src/redux/modules/analytics';

type Props = {
  styles: Styles;
  analyticsClick: (options: ClickAnalyticsOptions) => void;
  charity?: CharityState;
} & WrappedFieldProps;

interface State {
  showCharityNameAlert: boolean;
}

class PitchField extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      showCharityNameAlert: false,
    };
  }

  closeCharityNameAlert = () => {
    this.setState({
      showCharityNameAlert: false,
    });
  };

  handleBlur = async (e: React.FocusEvent<HTMLTextAreaElement>) => {
    const { input } = this.props;
    input.onBlur(e);

    const { value } = e.target;
    if (value.length > 0) {
      const hasCharityName = await containsCharityName(value);
      if (hasCharityName) {
        this.setState({
          showCharityNameAlert: true,
        });
      }
    }
  };

  handleFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    const { input } = this.props;
    const { showCharityNameAlert } = this.state;
    input.onFocus(e);

    input.onFocus(e);
    if (showCharityNameAlert) {
      this.closeCharityNameAlert();
    }
  };

  render() {
    const {
      input,
      styles,
      meta: { touched, error },
      analyticsClick,
    } = this.props;
    const { showCharityNameAlert } = this.state;
    const analyticsPageSection = 'create > charity notification';

    return (
      <div className="jg-space-mbms jg-space-mbmd@lg">
        <label className={classNames(styles.label)} htmlFor="pitchFor">
          <FormattedMessage id="PitchField.to" defaultMessage="to" />
        </label>
        <CharacterCount maxLength={140} value={input.value}>
          {({ charactersRemaining, isValid }) => {
            return (
              <div className={styles['pitch-wrapper']}>
                <textarea
                  {...input}
                  autoCapitalize="none"
                  placeholder="help fund a new playground"
                  className={styles.pitch}
                  onBlur={this.handleBlur}
                  onFocus={this.handleFocus}
                />
                <span
                  className={`jg-text--small-light ${
                    styles['character-count']
                  } ${!isValid ? 'jg-color--sunset-red' : ''}`}
                >
                  {charactersRemaining}
                </span>
              </div>
            );
          }}
        </CharacterCount>
        <ValidationResult touched={touched} error={error} />
        <p className={styles.note}>
          <FormattedMessage
            id="PitchField.youCanEditTitleLater"
            defaultMessage="You can edit your page title later."
          />
        </p>
        {showCharityNameAlert && (
          <div className="jg-space-mbmd">
            <Alert
              id="charity-name-alert"
              type="amber"
              displayType="inline"
              onClose={this.closeCharityNameAlert}
              analyticsClick={() =>
                analyticsClick({
                  event: 'click',
                  eventValue: 'x',
                  pageSection: analyticsPageSection,
                  subtype: 'button',
                })
              }
            >
              <FormattedMessage
                id="PitchField.charityNameAlertText"
                defaultMessage="It looks like you might be raising money for a registered charity? If so you'll need to {link}."
                values={{
                  link: (
                    <Link
                      href={FUNDRAISING_BASE_URI}
                      rel="noreferrer noopener"
                      target="_blank"
                      analyticsOptions={{
                        event: 'link click',
                        eventValue: 'create fundraising page',
                        pageSection: analyticsPageSection,
                        subtype: 'hyperlink',
                      }}
                    >
                      <FormattedMessage
                        id="PitchField.charityNameAlertText.fundraisingPageLink"
                        defaultMessage="create a Fundraising Page"
                      />
                    </Link>
                  ),
                }}
              />
            </Alert>
          </div>
        )}
      </div>
    );
  }
}

export default PitchField;



// WEBPACK FOOTER //
// ./src/components/CreateForm/PitchField.tsx